module.exports = __webpack_public_path__ + "img/illustration_van.4048bc90.png";